export class Floor {
    id: string;
    name: string;
    apartmentId: string;
    listOfRooms: Array<string>;
    position: number;
  }
